import refresh from './refresh';
import signIn from './signIn';
import singout from './singout';

export default function* () {
    yield* [
        ...refresh,
        ...signIn,
        ...singout
    ];
}
